import React from "react";
import ReactDOM from "react-dom";
import ReportListBlockView from "./ReportListBlockView";

export default class ReportListBlock {
  constructor(element) {
    this.element = element;
    this.view = element.querySelector(".js-report-list-block__root");
    this.init();
    console.log("ReportListBlock - Init");
  }

  init() {
    ReactDOM.render(<ReportListBlockView />, this.view);
  }
}
